import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import * as fromStore from 'src/app/store';

export const TicketsGuard = (): Observable<boolean> => {
  const store = inject<Store<fromStore.State>>(Store);

  const checkStore = (): Observable<boolean> =>
    store.select(fromStore.getTicketsLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          store.dispatch(new fromStore.LoadTickets());
        }
      }),
      filter((loaded) => loaded),
      take(1),
    );

  return checkStore().pipe(
    switchMap(() => of(true)),
    catchError(() => of(false)),
  );
};

